/**
 * Custom error class for Deepgram audio capture failures.
 * Used to distinguish audio capture errors from other errors in error handling.
 */
export class DeepgramAudioCaptureError extends Error {
  constructor(
    message: string,
    public readonly originalError?: unknown,
  ) {
    super(message);
    this.name = 'DeepgramAudioCaptureError';
    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, DeepgramAudioCaptureError);
    }
  }
}
